import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useGetSingleNewsQuery, useGetNewsPageFieldsQuery, useIncrementNewsViewCountMutation } from '../NewsPage/api/NewsApiApiSlice';
import SingleNewsCard from '../NewsPage/components/SingleNewsCard/SingleNewsCard';

import { ReactComponent as AdminIcon } from '../../assets/images/adminIcon.svg';
import styles from './styles/NewsSinglePage.module.scss';


function NewsSinglePage() {
  const { newsSlug } = useParams();
  const { data, isLoading, isFetching, isError, error } = useGetSingleNewsQuery(newsSlug);
  const { data: pageData, error: pageError, isLoading: pageLoading, isSuccess: pageIsSuccess } = useGetNewsPageFieldsQuery();
  const [incrementNewsViewCount, { isSuccess }] = useIncrementNewsViewCountMutation();

  useEffect(() => {
    if (data) {
      incrementNewsViewCount({ newsId: data.id });
    }
  }, [data, incrementNewsViewCount]);

  if (isLoading || isFetching) return <div>Loading...</div>;
  if (isError) return <div>Error loading news: {error.message}</div>;
  if (!data) return <div>No news item found</div>;

  // Format the publish date
  const publishDate = new Date(data.publish_date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Calculate "Posted X hours ago"
  const postedTime = (() => {
    const now = new Date();
    const publish = new Date(data.publish_date);
    const diffInHours = Math.floor((now - publish) / (1000 * 60 * 60));
    return diffInHours > 0
      ? `Posted ${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      : 'Posted recently';
  })();

  return (
    <div
      className={styles.articleContainer}
      style={{
        "--primary-color": pageData?.colors?.primary,
        "--secondary-color": pageData?.colors?.secondary,
        "--shadow-color": pageData?.colors?.shadow,
        "--line-color": pageData?.colors?.line,
      }}
    >
      <div className="container">
        <div className={styles.insightsTitle}>
          <span>INSIGHTS/BLOG</span>
        </div>
        <h1 className={styles.articleTitle}>{data.title}</h1>
        <div className={styles.articleMeta}>
          <div className={styles.iconWrapper}>
            <AdminIcon />
          </div>
          <div className={styles.metaInfo}>
            <span className={styles.AuthorName}>{data.author}</span>
            <span className={styles.Dot}>|</span>
            <span className={styles.Date}>{publishDate}</span>
            <span className={styles.Dot}>•</span>
            <span className={styles.PostedTime}>{postedTime}</span>
          </div>
        </div>

        {data.featured_image && (
          <div className={styles.articleImage}>
            <img
              src={data.featured_image.file}
              alt={data.featured_image.alternative_text}
            />
          </div>
        )}

        <div
          className={styles.articleContent}
          dangerouslySetInnerHTML={{ __html: data.content }}
        ></div>

        {data.related_news && data.related_news.length > 0 && (
          <div className={styles.relatedNews}>
            <h2>Related Posts</h2>
            <div className={styles.listingWrapper}>
              {data.related_news.map((newsItem) => (
                <div key={newsItem.id} className={styles.cardWrapper}>
                  <SingleNewsCard
                    image={newsItem.featured_image.file}
                    title={newsItem.title}
                    date={new Date(newsItem.publish_date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                    excerpt={newsItem.excerpt}
                    slug={newsItem.slug}
                    colors={pageData.colors}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewsSinglePage;